import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  ReportBrokenLinkActionTypes,
  ReportBrokenLinkFailedAction,
  ReportBrokenLinkHideModalAction,
  ReportBrokenLinkSuccessAction,
} from './report-broken-link.actions';
import { ReportBrokenLinkService } from './report-broken-link.service';

@Injectable()
export class ReportBrokenLinkEffects {
  constructor(
    private actions$: Actions,
    private reportBrokenLinkService: ReportBrokenLinkService,
  ) {}

  reportBrokenLink$: Observable<
    ReportBrokenLinkSuccessAction | ReportBrokenLinkFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK),
      mergeMap((action: ReportBrokenLinkSuccessAction) => {
        return this.reportBrokenLinkService
          .reportBrokenLink(action.payload.brokenLinkReport)
          .pipe(
            map(() => new ReportBrokenLinkSuccessAction(action.payload)),
            catchError(error =>
              observableOf(
                new ReportBrokenLinkFailedAction({
                  error,
                }),
              ),
            ),
          );
      }),
    ),
  );

  reportBrokenLinkHideModal$: Observable<ReportBrokenLinkHideModalAction> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(
          ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_SUCCESS,
          ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_CANCEL,
        ),
        mergeMap(() => observableOf(new ReportBrokenLinkHideModalAction())),
      ),
    );
}
